document.addEventListener('DOMContentLoaded', function(event) {
  var galleryLoader = document.querySelector('.image-gallery-loading');
  var galleryWrapper = document.querySelector('.image-gallery');
  galleryLoader.style.display = "none";
  galleryWrapper.style.display = "block";

  var sliderGallery = document.querySelector('#image-gallery-slider .snapslider-overflow');
  var swiper = new Swiper(sliderGallery, {
    cssMode: true,
    speed: 1000,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev"
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    autoplay: {
       delay: 5000,
      disableOnInteraction: true,
      pauseOnMouseEnter: true,
     },
    //wrapperClass: "snapslider-scroll",
    //slideClass: "snapslider-card",
    slidesPerView: "auto",
    mousewheel: true,
    keyboard: true,
  });


  Fancybox.bind("[social-media]", {
    Toolbar: {
      display: [
        "prev",
        "counter",
        "next",
        "thumbs",
        "close",
      ],
    },
  });
                          
})